import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { multipleOfOneThousand } from '@app/helpers';
import { UserSettingsAutoinvestContractComponent } from '@app/modules/user-settings/user-settings-autoinvest-contract/user-settings-autoinvest-contract.component';
import { UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'mnf-modal-modify-autoinvest',
  templateUrl: './modal-modify-autoinvest.component.html',
  styleUrls: ['./modal-modify-autoinvest.component.scss']
})
export class ModalModifyAutoinvestComponent {
     
  currentParagraph: number | null = 1;
  selectedValue: string | null = null;
  
  autoInvestForm = new FormGroup({
    selectedOption: new FormControl(null, Validators.required)
  });

  constructor(
    private dialogRef: MatDialogRef<any>,
    private dialog: MatDialog,
    private userServ: UserService,
    private toast: ToastrService,
    private modalServ: ModalService
  ) { }

  showParagraph(paragraphNumber: number): void {
    this.currentParagraph = paragraphNumber;
  }

  updateAutoinvest() {
    if (this.autoInvestForm.valid) {
       this.openAutoInvestContract();
    }
  }

  
  openAutoInvestContract() {

    let autoInvestForm = this.autoInvestForm.value;

    const types = [];
    if (autoInvestForm?.selectedOption == 'allProjects') { types.push("variable"); types.push("fixed"); }
    if (autoInvestForm?.selectedOption == 'variable') { types.push("variable"); }  
    if (autoInvestForm?.selectedOption == 'fixed') { types.push("fixed"); }

    const newObj = {
       minAmount: 1000,
       type: types
    };


    this.userServ.modifyDomiciliation(newObj).subscribe((res) => {
      if(res) {
        this.toast.success('Se ha modificado la domiciliación correctamente', 'Éxito');
        this.modalServ?.openModalConfirmMovementAutoInvest(res, false);
        this.dialogRef?.close();
      } else {
        this.toast.error('Ha ocurrido un error al modificar la domiciliación', 'Error');
      }
    })
  }

  onOptionChange(selectedValue: string) {
      this.selectedValue = selectedValue;
  }

  close() {
     this.dialogRef.close();
  }

}
